module.exports = __webpack_public_path__ + "img/ic_portrait2.59f0e792.svg";